import { capturedGet, capturedPost, capturedRemove, capturedPut } from '../../http'
import { createModule } from '@/global/store/modules/promotion'

export default createModule('ad-user', { capturedGet, capturedPost, capturedRemove, capturedPut })
